import styled, { css } from 'styled-components';

export const Container = styled.form`
  display: flex;
  align-items: start;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.l}rem;
`;

export const InputsContainer = styled.div`
  display: flex;
  align-items: end;
  gap: ${({ theme }) => theme.spaces.l}rem;
  flex-wrap: wrap;
  width: 100%;
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    gap: ${({ theme }) => theme.spaces.m}rem;
  }
`;

export const ColorInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xs}rem;
  position: relative;
`;

export const ColorPreview = styled.button<{ color: string }>`
  width: 40px;
  height: 40px;
  border-radius: 5px;
  background-color: ${({ color }) => color};
  border: 2px solid ${({ theme }) => theme.colors.greyLight};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.05);
    border-color: ${({ theme }) => theme.colors.garnet};
  }
`;

export const ColorPickerContainer = styled.div<{ $openToLeft?: boolean }>`
  position: absolute;
  top: 100%;
  /* Se despliega hacia la derecha por defecto, pero cuando el campo cae cerca
     del borde de la pantalla el paleta se salía y quedaba cortada (medido: en
     una ventana de 600 px llegaba a 675). Con "$openToLeft" se ancla por la
     derecha y crece hacia la izquierda. Es el espejo horizontal del "openUp"
     que ya usa DropDownList. */
  ${({ $openToLeft }) =>
    $openToLeft
      ? css`
          right: 0;
          left: auto;
        `
      : css`
          left: 0;
          right: auto;
        `};
  z-index: 1000;
  margin-top: ${({ theme }) => theme.spaces.xs}rem;
  padding: ${({ theme }) => theme.spaces.m}rem;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.greyLight};
  box-shadow: ${({ theme }) => theme.shadows.sm};

  .react-colorful {
    width: 200px;
    height: 200px;
  }

  .react-colorful__saturation {
    border-radius: 5px 5px 0 0;
  }

  .react-colorful__hue {
    height: 30px;
    border-radius: 0 0 5px 5px;
  }
`;

export const AddBudgetCategoryButton = styled.button`
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.white};
  min-height: 4rem;
  min-width: 4rem;
  width: 4rem;
  border: none;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.garnet};
`;
